import { withTranslation } from "@template/components/translation";
import styles from "./LoyaltyNewInBannerItem.deferred.css";
import PropTypes from "prop-types";

import asosWorldLogo from "../../assets/asos-world-logo.svg";
import padlock from "./assets/padlock.svg";
import JoinButton from "./JoinButton";
import {
  NEW_IN_TODAY_WOMEN_CATEGORY_ID,
  NEW_IN_TODAY_MEN_CATEGORY_ID
} from "./constants";
import { getAsosWorldUrl } from "./asosWorldUrls";
import cx from "classnames";
import SignInButton from "./SignInButton";
import LearnMoreLink from "./LearnMoreLink";
import TermsAndConditionsLinks from "./TermsAndConditionsLinks";
import NoisyText from "./NoisyText";
import {
  addCtaRefToUrl,
  generateNavigationCtaRef
} from "@template/helpers/addCtaRefToUrl";

const LoyaltyNewInBannerItem = ({
  defaultStoreUrl,
  enableComplianceVariant,
  formatTranslation,
  isMale,
  isOptedIn,
  itemCount,
  loggedIn,
  storeCode
}) => {
  const categoryId = isMale
    ? NEW_IN_TODAY_MEN_CATEGORY_ID
    : NEW_IN_TODAY_WOMEN_CATEGORY_ID;

  const includeItemCount = itemCount && itemCount >= 100;
  const showButton = !loggedIn || !isOptedIn;
  const showPadlock = !isOptedIn && !enableComplianceVariant;

  let newInTodayUrl = `${defaultStoreUrl}cat/?cid=${categoryId}`;

  if (!isOptedIn) {
    const ctaRef = generateNavigationCtaRef({
      label: "Join Now",
      linkType: "loyalty banner"
    });
    newInTodayUrl = addCtaRefToUrl(newInTodayUrl, ctaRef);
  }

  const lowItemCountTitle = isOptedIn
    ? formatTranslation("navigation_loyalty_new_in_title_opted_in")
    : formatTranslation("navigation_loyalty_new_in_title_opted_out");

  const text = isOptedIn
    ? formatTranslation("navigation_loyalty_new_in_text_opted_in")
    : formatTranslation("navigation_loyalty_new_in_text_opted_out");

  return (
    <>
      <div
        className={cx(styles.grid, {
          [styles.removeWhiteSpace]: isOptedIn
        })}
      >
        <div
          className={cx(styles.contentContainer, {
            [styles.contentContainerPadding]: isOptedIn,
            [styles.narrowContentContainer]: includeItemCount,
            [styles.complianceVariantContentContainer]: enableComplianceVariant
          })}
        >
          <img src={asosWorldLogo} className={styles.logo} alt="ASOS World" />

          {enableComplianceVariant ? (
            <NoisyText />
          ) : includeItemCount ? (
            <div className={styles.highCountTitle}>
              <span className={styles.itemCount}>{itemCount}</span>
              {formatTranslation("navigation_loyalty_new_in_title_with_count")}
            </div>
          ) : (
            <div className={styles.lowCountTitle}>{lowItemCountTitle}</div>
          )}

          {!enableComplianceVariant && <p className={styles.content}>{text}</p>}
        </div>

        {!enableComplianceVariant && (
          <div
            className={cx(styles.imageContainer, {
              [styles.wideImageContainer]: includeItemCount
            })}
          >
            {showPadlock && (
              <img
                src={padlock}
                className={styles.padlock}
                alt=""
                data-testid="padlock"
              />
            )}
          </div>
        )}
      </div>

      {showButton && (
        <div
          className={cx(styles.linksContainer, {
            [styles.linksContainerVariant]: enableComplianceVariant
          })}
        >
          {!loggedIn ? (
            <SignInButton>
              {formatTranslation("myaccountlinks_sign_in_label")}
            </SignInButton>
          ) : (
            <JoinButton href={newInTodayUrl}>
              {formatTranslation("navigation_loyalty_new_in_join_button")}
            </JoinButton>
          )}

          {enableComplianceVariant && (
            <LearnMoreLink
              href={defaultStoreUrl.concat(getAsosWorldUrl(storeCode))}
            >
              {formatTranslation("asos_world_learn_more_cta")}
            </LearnMoreLink>
          )}

          <TermsAndConditionsLinks
            defaultStoreUrl={defaultStoreUrl}
            enableComplianceVariant={enableComplianceVariant}
          />
        </div>
      )}
    </>
  );
};

LoyaltyNewInBannerItem.propTypes = {
  defaultStoreUrl: PropTypes.string.isRequired,
  enableComplianceVariant: PropTypes.bool.isRequired,
  formatTranslation: PropTypes.func.isRequired,
  isMale: PropTypes.bool.isRequired,
  isOptedIn: PropTypes.bool.isRequired,
  itemCount: PropTypes.number,
  loggedIn: PropTypes.bool.isRequired,
  storeCode: PropTypes.string.isRequired
};

export default withTranslation(LoyaltyNewInBannerItem);
